import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Alert as MUIAlert, AlertTitle as MUIAlertTitle, Collapse, Typography as MUITypography, } from "@mui/material";
import { Button } from "../Button";
import { Icon } from "../Icon";
import { convertPxToRem } from "../../util-functions";
const StyledAlert = styled(MUIAlert)(({ theme }) => ({
    display: "flex",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.green10.main,
    borderRadius: "unset",
    boxShadow: `0 ${convertPxToRem(12)} ${convertPxToRem(16)} ${convertPxToRem(-2)} rgba(0, 0, 0, 0.24)`,
    color: theme.palette.primaryWhiteText.main,
    height: "fit-content",
    padding: `${convertPxToRem(24)}`,
    zIndex: 999999,
    "& .MuiAlert-message": Object.assign(Object.assign({}, theme.typography.mediumText), { color: theme.palette.primaryWhiteText.main, display: "flex", padding: 0 }),
    "& .MuiAlert-action": {
        paddingTop: 0,
        paddingLeft: convertPxToRem(32),
    },
}));
const StyledIconContainer = styled("div")({
    "> span": {
        marginRight: convertPxToRem(12),
    },
});
const StyledTitle = styled(MUIAlertTitle)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.mediumTextStrong), { marginTop: convertPxToRem(-0.5) })));
const StyledMessage = styled(MUITypography)(({ theme }) => (Object.assign({}, theme.typography.mediumText)));
const StyledButtonsContainer = styled("div")({
    display: "flex",
    gap: convertPxToRem(8),
    marginTop: convertPxToRem(16),
});
export const MessageBanner = ({ iconName, message, onClose, open, primaryButtonProps, secondaryButtonProps, title, testId, }) => (_jsx(Collapse, Object.assign({ in: open }, { children: _jsxs(StyledAlert, Object.assign({ icon: false, onClose: onClose, "data-testid": testId }, { children: [_jsx(StyledIconContainer, { children: iconName && (_jsx(Icon, { iconName: iconName, color: "primaryWhiteText", testId: `icon-${testId}` })) }), _jsxs("div", { children: [_jsx(StyledTitle, Object.assign({ "data-testid": testId && `title-${testId}` }, { children: title })), _jsx(StyledMessage, Object.assign({ "data-testid": testId && `message-${testId}` }, { children: message })), _jsxs(StyledButtonsContainer, { children: [primaryButtonProps && (_jsx(Button, Object.assign({ variant: "primary" }, primaryButtonProps))), secondaryButtonProps && primaryButtonProps && (_jsx(Button, Object.assign({ variant: "secondary" }, secondaryButtonProps)))] })] })] })) })));
